export default __webpack_public_path__ + "static/media/logo-white.fe39b988.svg";